import { RiskItem } from '../types';

export function calculateRisk(likelihood: number, consequence: number): {
  score: number;
  level: RiskItem['riskLevel'];
} {
  const score = likelihood * consequence;
  const level: RiskItem['riskLevel'] =
    score <= 2 ? 'Low'
    : score <= 6 ? 'Medium'
    : score <= 12 ? 'High'
    : 'Extreme';
  return { score, level };
}

export function riskLevelColor(level: RiskItem['riskLevel']): string {
  switch (level) {
    case 'Low': return '#1a7a4a';
    case 'Medium': return '#b45309';
    case 'High': return '#a8431c';
    case 'Extreme': return '#c0392b';
  }
}

export function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

export function formatDateAU(d: Date): string {
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatTimeAU(d: Date): string {
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function buildPdfFileName(jobNumber: string, d: Date = new Date()): string {
  const sanitized = jobNumber.replace(/[^a-zA-Z0-9-]/g, '');
  return `${sanitized}-T5-${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}-${pad(d.getHours())}-${pad(d.getMinutes())}.pdf`;
}
